<template>
    <div id="productpage">
        <spinner-text v-if="!productDetails || !repairReasons">
            {{ trans('pages.product.loading') }}
        </spinner-text>
        <template v-else>
            <actions-menu ref="actionsButton">
                <actions-menu-item
                    v-if="
                        productDetails.orderType != 'S' &&
                        hasRight('productionmanagement')
                    "
                    id="orderForProductButton"
                    :v4="true"
                    class="back"
                    icon="arrow-left"
                    :action="orderForProductButtonClicked"
                    :label="trans('pages.product.to_order')"
                />
                <actions-menu-item
                    v-if="productDetails.orderType == 'S'"
                    :v4="true"
                    class="back"
                    icon="arrow-left"
                    :action="orderForProductButtonClicked"
                    :label="trans('pages.product.to_service')"
                />
                <actions-menu-item
                    v-if="productDetails.groupId"
                    :v4="true"
                    class="back"
                    icon="arrow-left"
                    :action="goToProductGroup"
                    :label="trans('pages.product.to_group')"
                />
                <actions-menu-item
                    id="editadditionalinfoproduct"
                    :v4="true"
                    icon="pencil"
                    :action="editAdditionalInfo"
                    :label="trans('pages.product.edit_info')"
                />
                <actions-menu-item
                    v-if="repairReasons"
                    ref="createServiceButton"
                    :v4="true"
                    icon="plus-circle"
                    :action="createService"
                    :label="trans('pages.product.create_service')"
                />
                <actions-menu-item
                    v-if="hasRight('administration')"
                    id="removeproduct"
                    :v4="true"
                    class="alert"
                    icon="exclamation-circle"
                    :action="removeProductClicked"
                    :label="trans('pages.product.remove')"
                />
                <actions-menu-item
                    v-if="!productDetails.partslistId"
                    :v4="true"
                    icon="paint-brush"
                    :action="calculatePartslist"
                    :label="trans('pages.product.calculate_parts_list')"
                />
                <actions-menu-item
                    id="productsaw"
                    :v4="true"
                    icon="list-ol"
                    :action="productSawClicked"
                    :label="trans('pages.product.saw_list')"
                />
                <actions-menu-item
                    id="productlabel"
                    :v4="true"
                    icon="tag"
                    :action="productLabelClicked"
                    :label="trans('pages.product.labels')"
                />
                <actions-menu-item
                    id="productProductionLabel"
                    :v4="true"
                    icon="tag"
                    :action="printProductionLabel"
                    :label="trans('pages.product.print_prod_label')"
                />
                <actions-menu-item
                    id="productProductionLabelForOrder"
                    :v4="true"
                    icon="tag"
                    :action="productProductionLabelForOrderClicked"
                    :label="trans('pages.product.prod_labels_for_order')"
                />
                <actions-menu-item
                    v-if="productDetails.producttypeId == 1"
                    id="productSawLabel"
                    :v4="true"
                    icon="tag"
                    :action="productSawLabelClicked"
                    :label="trans('pages.product.print_vlr_label')"
                />
                <actions-menu-item
                    v-if="productDetails.orderType == 'S'"
                    id="productRetourLabel"
                    :v4="true"
                    icon="tag"
                    :action="productRetourLabelClicked"
                    :label="trans('pages.product.print_return_label')"
                />
                <actions-menu-item
                    v-if="productDetails.orderType == 'S'"
                    id="productRetourLabelExport"
                    :v4="true"
                    icon="tag"
                    :action="productRetourLabelExportClicked"
                    :label="trans('pages.product.return_label')"
                />
                <actions-menu-item
                    v-if="productDetails.producttypeId == 16"
                    id="productBetioLabel"
                    :v4="true"
                    icon="tag"
                    :action="productBetioLabelClicked"
                    :label="trans('pages.product.print_betio_label')"
                />
                <actions-menu-item
                    id="productdetails"
                    :v4="true"
                    icon="info-circle"
                    :action="productDetailsClicked"
                    :label="trans('pages.product.production_slip')"
                />
                <actions-menu-item
                    v-if="hasRight('productionmanagement') && repairReasons"
                    id="producterror"
                    :v4="true"
                    icon="exclamation-circle"
                    :action="productErrorClicked"
                    :label="trans('pages.product.report_error')"
                />
                <actions-menu-item
                    v-if="hasRight('productionmanagement')"
                    id="producthistory"
                    :v4="true"
                    icon="history"
                    :action="productHistoryClicked"
                    :label="trans('pages.product.history')"
                />
                <actions-menu-item
                    id="expressoptimizedpaintlist"
                    :v4="true"
                    icon="fast-forward"
                    :action="expressOptimizedPaintlist"
                    :label="trans('pages.product.express_paint_slip')"
                />
                <actions-menu-item
                    v-if="hasRight('administration')"
                    id="downloadProductAttachments"
                    :v4="true"
                    icon="folder"
                    :action="downloadProductAttachments"
                    :label="trans('pages.product.download_attachments')"
                />
            </actions-menu>
            <div class="leftcolumn">
                <div class="productdefaultfields">
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.customer') }}
                        </span>
                        <span
                            id="productcustomer"
                            class="productpagevalue"
                        >
                            {{ productDetails.customerName }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.name') }}
                        </span>
                        <span
                            id="productname"
                            class="productpagevalue"
                        >
                            {{ productDetails.name }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.status') }}
                        </span>
                        <span
                            id="productstatus"
                            class="productpagevalue"
                        >
                            {{ productDetails.productstatus }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.reference') }}
                        </span>
                        <span
                            id="productref"
                            class="productpagevalue"
                        >
                            {{ productDetails.reference }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.ral_number') }}
                        </span>
                        <span
                            id="productralnr"
                            class="productpagevalue"
                        >
                            {{ productDetails.color.ralnr }}
                        </span>
                    </div>
                    <div
                        class="productpagefield"
                        v-if="
                            productDetails &&
                            productDetails.optimizedpaintlistIds &&
                            productDetails.optimizedpaintlistIds[0]
                        "
                    >
                        <span class="productpagename">
                            {{ trans('pages.product.paint_slip') }}
                        </span>
                        <span
                            id="productpaintlist"
                            class="productpagevalue"
                        >
                            <span
                                style="font-size: 8pt"
                                v-if="
                                    productDetails.optimizedpaintlistIds
                                        .length > 1
                                "
                            >
                                (
                                <span
                                    class="link"
                                    ref="optimizedPaintlistHistoryLink"
                                    @click="
                                        $refs.popoverOptimizedPaintlistHistory.showAt(
                                            $refs.optimizedPaintlistHistoryLink
                                        )
                                    "
                                >
                                    {{ trans('pages.product.history') }}
                                </span>
                                )
                            </span>
                        </span>
                    </div>
                    <div class="wideproductpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.ral_type') }}
                        </span>
                        <span
                            id="productraltype"
                            class="productpagevalue"
                        >
                            {{ productDetails.color.raltype }}
                        </span>
                    </div>
                    <div class="wideproductpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.powder_number') }}
                        </span>
                        <span
                            id="productpoedernr"
                            class="productpagevalue"
                        >
                            {{ productDetails.color.poedernr }}
                        </span>
                    </div>
                    <div
                        class="productpagefield"
                        v-if="hasRight('administration')"
                    >
                        <span class="productpagename">
                            {{ trans('pages.product.price') }}
                        </span>
                        <span
                            id="productprice"
                            class="productpagevalue"
                        >
                            {{ formatPrice(productDetails.price) }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.count') }}
                        </span>
                        <span
                            id="productcount"
                            class="productpagevalue"
                        >
                            {{ productDetails.count }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.error') }}
                        </span>
                        <span
                            class="productpagevalue"
                            v-if="productDetails && productDetails.statuserror"
                        >
                            {{ productDetails.statuserror }}
                        </span>
                    </div>
                    <div class="wideproductpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.ral_info') }}
                        </span>
                        <span
                            id="productralinfo"
                            class="productpagevalue"
                        >
                            {{ productDetails.color.colornotes }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.box_number') }}
                        </span>
                        <span
                            id="productboxnr"
                            class="productpagevalue"
                        >
                            {{ productDetails.boxnr }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.colli_number') }}
                        </span>
                        <span
                            id="productcolli"
                            class="productpagevalue"
                        >
                            {{ productDetails.colli }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.repair_reason') }}
                        </span>
                        <span
                            id="productrepairreason"
                            class="productpagevalue"
                        >
                            {{ productDetails.repairReasonName }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.internal_url') }}
                        </span>
                        <a
                            target="_blank"
                            v-if="productDetails.internUrl"
                            :href="productDetails.internUrl"
                            class="productpagevalue"
                        >
                            {{ trans('pages.product.open_link') }}
                        </a>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.external_url') }}
                        </span>
                        <a
                            target="_blank"
                            v-if="productDetails.externUrl"
                            :href="productDetails.externUrl"
                            class="productpagevalue"
                        >
                            {{ trans('pages.product.open_link') }}
                        </a>
                    </div>
                    <div class="spacer" />
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.production_date') }}
                        </span>
                        <span
                            id="productionDate"
                            class="productpagevalue"
                        >
                            {{ productDetails.productionDate }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.original_delivery_date') }}
                        </span>
                        <span
                            id="originalDeliveryDate"
                            class="productpagevalue"
                        >
                            {{ productDetails.originalDeliveryDate }}
                        </span>
                    </div>
                    <div class="productpagefield">
                        <span class="productpagename">
                            {{ trans('pages.product.delivery_date') }}
                        </span>
                        <span
                            id="deliveryDate"
                            class="productpagevalue"
                        >
                            {{ productDetails.deliveryDate }}
                        </span>
                    </div>
                    <div class="spacer" />
                    <div>
                        <div class="productpagefield">
                            <span class="productpagename">
                                {{ trans('pages.product.pickup_ride_number') }}
                            </span>
                            <span
                                id="pickupDatenr"
                                class="productpagevalue"
                            >
                                {{ productDetails.pickupDateKey }}
                            </span>
                        </div>
                    </div>
                    <div>
                        <div class="productpagefield">
                            <span class="productpagename">
                                {{
                                    trans('pages.product.delivery_ride_number')
                                }}
                            </span>
                            <span
                                id="deliveryDatenr"
                                class="productpagevalue"
                            >
                                {{ productDetails.deliveryDateKey }}
                            </span>
                        </div>
                    </div>
                    <p
                        class="wideproductpagefield"
                        id="productnote"
                    >
                        {{ trans('pages.product.notes') }}:
                        {{ productDetails.note }}
                    </p>
                </div>
                <div id="productfields"></div>
                <div id="productfields2">
                    <div
                        class="productpagefield"
                        v-for="dataField in productDetails.datafields"
                        :key="dataField.datafieldId"
                    >
                        <span class="productpagename">
                            {{ dataField.label }}
                        </span>
                        <span class="productpagevalue">
                            {{ getDatafieldValue(dataField) }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="rightcolumn">
                <img
                    id="productImage"
                    ref="productImage"
                    onerror="this.style.display = 'none';"
                    :src="productImageUrl"
                    @click="
                        $refs.popoverProductImage.showAt($refs.productImage)
                    "
                />

                <h3>{{ trans('pages.product.slips') }}</h3>
                <productlists :product="productDetails"></productlists>

                <h3>{{ trans('pages.product.linked_product') }}</h3>
                <div v-if="extendedDetails">
                    <template v-if="extendedDetails.originalProduct">
                        <p>
                            {{
                                sanitizeProductLabel(
                                    extendedDetails.originalProduct
                                )
                            }}
                            <br />
                            <ui5-button
                                @click="
                                    goToProductPage(
                                        extendedDetails.originalProduct
                                            .productId
                                    )
                                "
                            >
                                {{ trans('pages.product.to_product') }}
                            </ui5-button>
                        </p>
                    </template>
                    <template v-else-if="extendedDetails.newProducts">
                        <p
                            v-for="newProduct in extendedDetails.newProducts"
                            :key="newProduct.productId"
                        >
                            {{ sanitizeProductLabel(newProduct) }}
                            <br />
                            <ui5-button
                                @click="goToProductPage(newProduct.productId)"
                            >
                                {{ trans('pages.product.to_product') }}
                            </ui5-button>
                        </p>
                    </template>
                </div>
                <h3>{{ trans('pages.product.products_from_order') }}</h3>
                <div v-if="!extendedDetails">
                    <ui5-button
                        id="load-productinfo"
                        @click="loadProductInfo"
                    >
                        {{ trans('pages.product.load_info') }}
                    </ui5-button>
                    <spinner-text v-if="loadingExtended">
                        {{ trans('pages.product.loading_products') }}
                    </spinner-text>
                </div>
                <div v-else>
                    <template v-if="extendedDetails.orderProducts">
                        <p
                            v-for="orderProduct in extendedDetails.orderProducts"
                            :key="orderProduct.productId"
                        >
                            <span
                                v-html="sanitizeProductLabel(orderProduct)"
                            ></span>
                            <br />
                            <ui5-button
                                @click="goToProductPage(orderProduct.productId)"
                            >
                                {{ trans('pages.product.to_product') }}
                            </ui5-button>
                        </p>
                    </template>
                </div>
            </div>
            <popover-repair-reason-form
                :product-id="productId"
                :header-text="trans('pages.product.create_service')"
                ref="popoverMakeService"
                :action="makeServiceAction"
                :repair-reasons="repairReasons"
            />
            <popover-repair-reason-form
                :product-id="productId"
                :header-text="trans('pages.product.report_error')"
                ref="popoverProductError"
                :action="makeErrorAction"
                :repair-reasons="repairReasons"
            />
            <ui5-popover
                id="popover-product-image"
                ref="popoverProductImage"
                horizontal-align="Center"
                vertical-align="Center"
            >
                <div>
                    <img
                        :src="productImageUrl"
                        id="productpageproductimagezoom"
                        @click="$refs.popoverProductImage.close()"
                    />
                </div>
            </ui5-popover>
            <ui5-popover
                id="popover-optimized-paintlist-history"
                ref="popoverOptimizedPaintlistHistory"
            >
                <h1>{{ trans('pages.product.history') }}</h1>
                <table
                    id="productpageoptimizedpaintlisthistorytable"
                    v-if="
                        productDetails && productDetails.optimizedpaintlistIds
                    "
                >
                    <tr
                        v-for="opList in productDetails.optimizedpaintlistIds"
                        :key="opList.ID"
                    >
                        <td
                            class="link"
                            @click="
                                $router.push(
                                    '/optimizedpaintlistview/' + opList.ID
                                )
                            "
                        >
                            {{ opList.ID }}
                        </td>
                        <td>{{ opList.creationDate }}</td>
                    </tr>
                </table>
            </ui5-popover>
        </template>
    </div>
</template>
<script>
import productAttachmentApi from '../api/productAttachment';
import productApi from '../api/product';
import repairApi from '../api/repair';
import exportApi from '../api/export';
import sawlineApi from '../api/sawline';
import partslistApi from '../api/partslist';
import ActionsMenuItem from '../components/ActionsMenuItem';
import ActionsMenu from '../components/ActionsMenu';
import SpinnerText from '../components/loader/SpinnerText';
import PopoverRepairReasonForm from '../components/products/PopoverRepairReasonForm';
import RepairReasonActionsMixin from '../mixins/repair-reason-actions';
import IdParamMixin from '../mixins/id-param';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import { mapGetters } from 'vuex';
import Productlists from '../components/productlists/Productlists.vue';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';
import paintListCreatedDialog from '../components/dialogs/PaintListCreatedDialog';
import { saveAs } from 'file-saver';
import localization from '../mixins/localization';
import CurrencyHelper from '../helpers/CurrencyHelper';

export default {
    components: {
        PopoverRepairReasonForm,
        SpinnerText,
        ActionsMenu,
        ActionsMenuItem,
        Productlists,
    },
    mixins: [
        RepairReasonActionsMixin,
        IdParamMixin(),
        NavigationFunctionsMixin,
        localization,
    ],
    computed: {
        ...mapGetters({
            hasRight: 'currentUser/hasRight',
        }),
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
            ]();
        },
        productImageUrl() {
            return (
                Config.url + '/product/customImage/?productId=' + this.productId
            );
        },
    },
    methods: {
        formatPrice(value) {
            return CurrencyHelper.formatPrice(value, this.currentLocaleIso2Code());
        },
        calculatePartslist() {
            showConfirmDialog({
                title: this.trans('pages.product.calculate_parts_list'),
                content: this.trans(
                    'pages.product.confirm_calculate_parts_list'
                ),
                confirm: () => {
                    partslistApi
                        .recalculate(this.productId)
                        .then((response) => {
                            showInfoMessage(
                                this.trans('pages.product.calculation_success')
                            );
                            this.productDetails.partslistId =
                                response.data.data.newPartslistId;
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans('pages.product.calculation_failed')
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.product.yes'),
                cancelButton: this.trans('pages.product.no'),
            });
        },
        getDatafieldValue(dataField) {
            let value = dataField.fieldvalue;

            switch (parseInt(dataField.datatype)) {
                case 1: // boolean
                    value =
                        value == '1'
                            ? this.trans('pages.product.true')
                            : this.trans('pages.product.false');
                    break;
                case 6: // table
                case 8: // popup
                case 9: // multiselect
                    value += ' ' + dataField.fieldvaluedescription;
                    break;
            }

            return value;
        },
        goToProductGroup() {
            this.$router.push(
                '/productgrouppage/' + this.productDetails.groupId
            );
        },
        sanitizeProductLabel(product) {
            let label = product.label.replace(/~~/g, '<br/>');
            label = label.replace(/-/g, '<br/>');
            label = label.replace(/<b>/g, '');
            label = label.replace(/<n>/g, '');
            return label;
        },
        productDetailsClicked() {
            this.$router.push('/productdetails/' + this.productId);
        },
        expressOptimizedPaintlist() {
            const self = this;
            showConfirmDialog({
                title: this.trans('pages.product.create_express_paint_slip'),
                content: this.trans(
                    'pages.product.confirm_create_express_paint_slip'
                ),
                confirm: (dialog) => {
                    const optimizedpaintlistIds =
                        this.productDetails.optimizedpaintlistIds;
                    const optimizedpaintlistId =
                        optimizedpaintlistIds && optimizedpaintlistIds.length
                            ? optimizedpaintlistIds[0].ID
                            : null;
                    sawlineApi
                        .expressOptimizedPaintlistForProduct(
                            parseInt(this.productId),
                            optimizedpaintlistId
                        )
                        .then((response) => {
                            const newPaintList = response.data.data;
                            paintListCreatedDialog(newPaintList)
                                .then(() => {
                                    self.navigateToOptimizedPaintlistView(
                                        newPaintList.id
                                    );
                                })
                                .catch(() => {
                                    self.$router.go();
                                });
                        })
                        .catch((ex) => {
                            console.error(ex);
                            showErrorMessage(
                                this.trans(
                                    'pages.product.unknown_error_creating_express_paint_slip'
                                )
                            );
                        });
                    dialog.close();
                },
                cancel: (dialog) => {
                    dialog.close();
                },
                confirmButton: this.trans('pages.product.yes'),
                cancelButton: this.trans('pages.product.no'),
            });
        },
        orderForProductButtonClicked() {
            // Button to go back from productpage to according order
            // add correct action to button
            // Generate button to go back to order of this product
            this.$router.push(
                '/editproduct/?orderId=' +
                    this.orderId +
                    '&productId=' +
                    this.productId +
                    '&productState=edit-product'
            );
        },
        loadProductInfo() {
            this.loadingExtended = true;
            productApi
                .fetchExtendedDetails(this.productId)
                .then((response) => {
                    this.extendedDetails = response.data.data;
                })
                .finally(() => {
                    this.loadingExtended = false;
                });
        },
        createService() {
            this.$refs.popoverMakeService.open(this.$refs.actionsButton.$el);
        },
        productErrorClicked() {
            this.$refs.popoverProductError.open(this.$refs.actionsButton.$el);
        },
        editAdditionalInfo() {
            this.$router.push('/productinfo/' + this.productId);
        },
        productSawClicked() {
            this.$router.push('/productsaw/' + this.productId);
        },
        printProductionLabel() {
            if (KeyHelper.isPressed('Shift')) {
                exportApi
                    .exportProductionLabel(this.productId)
                    .then((response) => {
                        const blobUrl = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = blobUrl;
                        link.target = '_blank';
                        link.download = `production-label-${this.productId}.pdf`;
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        window.URL.revokeObjectURL(blobUrl);
                        document.body.removeChild(link);
                    })
                    .catch(() => {
                        showErrorMessage(
                            this.trans('pages.product.unknown_error_printing_prod_labels')
                        );
                    });

                return;
            }

            exportApi
                .printProductionLabel(
                    this.productId,
                    this.selectedPrinterPostParameter
                )
                .then(() => {
                    showInfoMessage(this.trans('pages.product.labels_printed'));
                });
        },
        productLabelClicked() {
            this.$router.push('/productlabels/' + this.productId);
        },
        productProductionLabelForOrderClicked() {
            if (KeyHelper.isPressed('Shift')) {
                exportApi
                    .exportProductionLabelsForOrder(this.orderId)
                    .then((response) => {
                        // Create a URL to the blob data
                        const blobUrl = window.URL.createObjectURL(
                            new Blob([response.data])
                        );

                        // Create a temporary link element and trigger a click event
                        const link = document.createElement('a');
                        link.href = blobUrl;
                        link.target = '_blank';
                        link.download = `production-label-for-order-${this.orderId}.pdf`;
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();

                        // Clean up
                        window.URL.revokeObjectURL(blobUrl);
                        document.body.removeChild(link);
                    })
                    .catch(() => {
                        showErrorMessage(
                            this.trans(
                                'pages.product.unknown_error_printing_prod_labels'
                            )
                        );
                    });

                return;
            }

            exportApi
                .printProductionLabelsForOrder(
                    this.orderId,
                    this.selectedPrinterPostParameter
                )
                .then(() => {
                    showInfoMessage(this.trans('pages.product.labels_printed'));
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.product.unknown_error_printing_prod_labels'
                        )
                    );
                });
        },
        productSawLabelClicked() {
            exportApi
                .printWindowLabel(
                    this.productId,
                    this.selectedPrinterPostParameter
                )
                .then(() => {
                    showInfoMessage(this.trans('pages.product.labels_printed'));
                });
        },
        productRetourLabelClicked() {
            exportApi
                .printRetourLabel(
                    this.productId,
                    this.selectedPrinterPostParameter
                )
                .then(() => {
                    showInfoMessage(this.trans('pages.product.labels_printed'));
                });
        },
        productBetioLabelClicked() {
            exportApi
                .printTransportLabel(
                    this.productId,
                    this.selectedPrinterPostParameter
                )
                .then(() => {
                    showInfoMessage(this.trans('pages.product.labels_printed'));
                });
        },
        productHistoryClicked() {
            this.$router.push('/producthistory/' + this.productId);
        },
        productRetourLabelExportClicked() {
            window.open(
                Config.url +
                    '/export/exportRetourLabel/?productId=' +
                    this.productId,
                '_blank'
            );
        },
        removeProductClicked() {
            showConfirmDialog({
                title: this.trans('pages.product.remove_product'),
                content: this.trans('pages.product.confirm_remove_product'),
                confirm: () => {
                    productApi
                        .remove(this.productId)
                        .then(() => {
                            this.$router.push('/menu');
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans(
                                    'pages.product.product_could_not_be_removed'
                                )
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.product.yes'),
                cancelButton: this.trans('pages.product.no'),
            });
        },
        load() {
            this.productId = this.$route.params.id;
            this.productDetails = null;

            productApi
                .fetchProductDetails(this.productId, true)
                .then((response) => {
                    this.productDetails = response.data.data;
                    this.orderId = this.productDetails.orderId;
                    this.$store.commit(
                        'general/setPageTitle',
                        this.productDetails.producttypeName +
                            ' ' +
                            this.productDetails.productNr,
                        { root: true }
                    );
                });

            repairApi.list().then((response) => {
                this.repairReasons = response.data.data;
            });
        },
        downloadProductAttachments() {
            showInfoMessage(
                this.trans('pages.product.downloading_product_attachments')
            );

            productAttachmentApi
                .fetchByProductId(this.productId)
                .then(function (response) {
                    const blob = new Blob([response.data], {
                        type: 'application/zip',
                    });
                    saveAs(
                        blob,
                        response.headers['content-disposition']
                            .split(';')[1]
                            .split('=')[1]
                    );
                })
                .catch((error) => {
                    if (error.response?.status === 404) {
                        showErrorMessage(
                            this.trans(
                                'pages.product.no_product_attachments_found'
                            )
                        );
                        return;
                    }
                    showErrorMessage(
                        this.trans(
                            'pages.product.error_downloading_product_attachments'
                        )
                    );
                });
        },
    },
    data() {
        return {
            productId: null,
            orderId: null,
            productDetails: null,
            repairReasons: null,
            extendedDetails: null,
            loadingExtended: false,
        };
    },
};
</script>
